import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary as BugsnagErrorBoundary } from 'components/error/bugsnag';
import { Error500 } from '../../pages';

const ErrorBoundary = ({ children }) => (
  <BugsnagErrorBoundary FallbackComponent={Error500}>
    {children}
  </BugsnagErrorBoundary>
);

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
